import FixedTopNotification from 'components/FixedTopNotification/FixedTopNotification'
import { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { notificationStatus } from 'constants/notificationStatus'
import {  useState } from 'react'
import { UserDataType } from 'types/autentication'
import { NotificationType } from 'types/notification'
import { checkSameSectorAndLocation } from '../Header/Children/Buttons/AssumeTreatment'
import ExclamationIcon from 'components/Icons/ExclamationIcon'

export interface ICanNotEditInfo {
  currentUser: UserDataType
  notificationLocation: string
  notificationSector: string
  notificationById: NotificationType
  notificationStatusState: string
}

export const hasPermissionToEdit = (
  {  isSameLocation, isSameSector, notificationStatusState }:
      {  isSameLocation: boolean, isSameSector: boolean, notificationStatusState: string }) => {
  // Status "Pendente Finalização" - permite admin, location_qa e corporate_quality_board
  if (notificationStatusState === notificationStatus[3].label) {
      return [
          listOfRoles.admin,
          listOfRoles.location_qa,
          listOfRoles.corporate_quality_board
      ]
  }
  
  // Status "Nova" ou "Aguardando" - não exige que o usuário seja responsável
  // pois ainda não há usuário atribuído à notificação
  if (notificationStatusState === notificationStatus[0].label || 
      notificationStatusState === notificationStatus[1].label) {
      return [
          listOfRoles.admin,
          ...(isSameLocation && isSameSector ? [listOfRoles.location_manager] : []),
          ...(isSameLocation ? [listOfRoles.location_qa] : []),
          listOfRoles.corporate_quality_board
      ]
  }
  
  // Outros status - permite admin, location_manager (mesma localização/setor), location_qa (mesma localização)
  // e corporate_quality_board (sempre, para poder editar orientação)
  return [
      listOfRoles.admin,
      ...(isSameLocation && isSameSector ? [listOfRoles.location_manager] : []),
      ...(isSameLocation ? [listOfRoles.location_qa] : []),
      listOfRoles.corporate_quality_board
  ]
}

export default function CanNotEditInfo({
  currentUser, notificationLocation,
    notificationSector, notificationById, notificationStatusState }: ICanNotEditInfo) {
    const [show, setShow] = useState(true)
    

    const {isSameLocation,isSameSector} = checkSameSectorAndLocation({currentUser,
      notificationLocation,
      notificationSector
    })
    const canEdit = hasPermissionToEdit( {  isSameLocation, isSameSector, notificationStatusState })

    if (!currentUser?.profile || !notificationById|| canEdit.includes(currentUser?.profile)) {
      return null
    }
    return (
        <FixedTopNotification
            show={show}
            handleClose={() => {
                setShow(false)
            }}
        >
            <div className="flex items-center"
            data-testid="test-can-not-edit-info"
            >
                <div className="mr-1">
                <ExclamationIcon
              />
                </div>
                <span className="text-sm font-bold">
                    Você não tem permissão para editar essa notificação.
                </span>
            </div>
        </FixedTopNotification>
    )
}
